import {
  type AiGenerateDockLinkSourceType,
  type AiGenerateDockSourceType,
} from '../consts/aiGenerateDock.const';
import { type AiGenerateDockAttachment } from '../types/aiGenerateDock.types';

/** 입력칸 위 자료 줄에 무엇을 놓을지. */
export type AiGenerateDockSourceRowState =
  | { kind: 'attachment'; attachment: AiGenerateDockAttachment }
  | { kind: 'file' }
  | { kind: 'link'; sourceType: AiGenerateDockLinkSourceType }
  | { kind: 'none' };

const isLinkSource = (
  sourceType: AiGenerateDockSourceType,
): sourceType is AiGenerateDockLinkSourceType =>
  sourceType === 'youtube' || sourceType === 'website';

/** 붙은 자료가 있으면 탭과 무관하게 칩을 놓는다. 없으면 탭이 고른다 — 주제 탭은 비운다. */
export const resolveAiGenerateDockSourceRow = (
  sourceType: AiGenerateDockSourceType,
  attachment: AiGenerateDockAttachment | null,
): AiGenerateDockSourceRowState => {
  if (attachment) return { kind: 'attachment', attachment };
  if (sourceType === 'file') return { kind: 'file' };
  if (isLinkSource(sourceType)) return { kind: 'link', sourceType };
  return { kind: 'none' };
};
